/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificationTitle } from '../../models/notification-title';
import { UserAlertNotificationSetting } from '../../models/user-alert-notification-setting';

export interface FindByTitle_1$Params {
  title: NotificationTitle;
}

export function findByTitle_1(http: HttpClient, rootUrl: string, params: FindByTitle_1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserAlertNotificationSetting>>> {
  const rb = new RequestBuilder(rootUrl, findByTitle_1.PATH, 'get');
  if (params) {
    rb.path('title', params.title, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserAlertNotificationSetting>>;
    })
  );
}

findByTitle_1.PATH = '/api/user/notification/alert/setting/title/{title}';
